import { SourceBasedExpression } from '../Expression.js';
export class FirstExpression extends SourceBasedExpression {
    evaluate(visitor, localVariables) {
        const source = this.getSource().evaluate(visitor, localVariables);
        if (source instanceof Array) {
            return source[0];
        }
    }
}
//# sourceMappingURL=FirstExpression.js.map